import React, { useState } from "react";
import "../../css/Login.css";
import { ReactComponent as Logo } from "../../assets/logotipo_cor.svg";
import { login } from '../../services/users/AuthService';
import { resetNavBarState } from '../../services/global/Utils';
import authEvents from '../../services/users/AuthEvents';
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import PasswordInput from "../../components/global/PasswordInput";

export default function Login() {

    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        setError("");
        
        try {
            await login(username, password);
            resetNavBarState();
            authEvents.emit("LOGGED_OUT");
            navigate("/homepage", { replace: true });
        } catch (e) {
            var message = e.message === "Bad credentials" ? "Dados Inválidos" : e.message;
            setError(message);
            setLoading(false);
        }
    }

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleLogin}>
                <div className="login-logo-wrapper">
                    <Logo className="login-logo" />
                </div>

                <div className="login-title">
                    <p>Sistema de Gestão de Orçamentos</p>
                </div>

                {error && <p className="login-error">{error}</p>}

                {loading &&
                    <div className="login-loading">
                        <CircularProgress disableShrink className="login-spinner" size={40} />
                    </div>
                }

                <input
                    type="text"
                    value={username}
                    onChange={(e) => { setUsername(e.target.value); setError("") }}
                    placeholder="Utilizador"
                    disabled={loading}
                    required
                />

                <PasswordInput
                    value={password}
                    onChange={setPassword}
                    placeholder="Palavra-passe"
                    disabled={loading}
                />
                <button type="submit" disabled={loading}>
                    {loading ? "A iniciar sessão..." : "Iniciar Sessão"}
                </button>

                <div className="login-footer">
                    <a href="/recover-password" className="login-recover-link">Recuperar palavra-passe?</a>
                </div>
            </form>
        </div>
    );
}
